export default {
    category: {
        cta: "Bekijk producten"
    }
}